<template>
    <div class="content">
        <div class="activation-status">{{status}}</div>
    </div>
</template>

<script>
export default {
    name: "Failed",
    props: {
        status: {
            type: String,
            default: "Activation failed."
        }
    }
};
</script>

<style scoped>
.content {
    text-align: center;
    margin: auto;
    width: 300px;
}

.activation-status {
    color: #fff;
    font-size: 24px;
    font-weight: bolder;
    font-weight: 300;
    margin: auto;
    padding: 70px 40px 40px 40px;
    display: block;
}
</style>

